module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-testimonials"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Cauê Ferreira",
      "image": "static/caue.png"
    }
  }, [_c('p', [_vm._v("Bem, você gostaria de trabalhar em uma empresa repleta de amigos, que são os melhores devs que você conhece, todos muito legais, solícitos, humildes; onde você se diverte e aprende algo novo todo dia? Onde você trabalha com todo tipo de tecnologia e ainda tem tempo para trocar uma ideia e sair com a galera? Sim? Pois é, eu também.")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Cauê Ferreira")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Filipe",
      "image": "static/filipe.png"
    }
  }, [_c('p', [_vm._v("\n        Porque aqui somos estimulados a inovar sem medo de errar. Além disso o respeito ao indivíduo é algo sempre presente, por isso não só desenvolvemos nossas habilidades profissionais mas também duradouras amizades.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Filipe Santos")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Caio Incau",
      "image": "static/caio.png"
    }
  }, [_c('p', [_vm._v("Trabalhar no Moip é incrível, um local onde temos todo o apoio para nos desenvolvermos profissionalmente, além de tudo que a empresa propicia, o ambiente é ótimo para desenvolvermos amizades que vão além do dia a dia de trabalho.")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Caio Incau")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Andre",
      "image": "static/andre.png"
    }
  }, [_c('p', [_vm._v("Moip é de longe a empresa com a qual mais me identifiquei ao longo da minha carreira profissional! Nunca estive em outro lugar que incentivasse tanto o meu aprendizado e crescimento. As opiniões de todos tem valor desde o primeiro dia e isso para mim é um grande diferencial.")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Andre Protti")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Gabriela Emi Sanada",
      "image": "static/gaby-2.jpg",
      "selected": true
    }
  }, [_c('p', [_vm._v("Nunca esperei trabalhar num lugar onde minha opinião fosse tão valorizada e respeitada quanto ela é aqui, por mais que eu possa estar errada aprendi a me expressar sem medo, pois sei que estou entre amigos.")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Gabriela Emi Sanada")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ebd01452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingTestimonials.vue
// module id = 149
// module chunks = 1